import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/user/login/',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/api/user/info/',
    method: 'get',
    params: data
  })
}

export function logout() {
  return request({
    url: '/api/user/logout/',
    method: 'get'
  })
}


// orgInfo
export function getOrgInfo(data) {
  return request({
    url: '/api/org/',
    method: 'get',
    data
  })
}


// 获取多班级
export const getUserGrade = (params) => request.get('/api/user/get_user_grade', { params })

// 获取批量生成的作品集
export const batchImgIndex = (params) => request.get('/api/aigc/batch_img_index', { params })

// 个人作品详情
export const batcImg = (id, params) => request.get(`/api/aigc/batch_img/${id}`, { params })

// 删除个人作品
export const delBatcImg = (id) => request.get(`/api/aigc/batch_img_delete/${id}`)

// 批量删除作品
export const batchImgDel = (data) => request.post(`/api/aigc/batch_img_delete`, data)

// 发布作品
export const worksAiStore = (data) => request.post(`/api/student_works/ai_store`, data)


// WEBPACK FOOTER //
// ./src/api/user.js